<template lang="pug">
  div(class="otp-input-container")
    div(:class="['otp-input-fields', { 'otp-error': errorMessage }]")
      input(
        v-for="(_, idx) in length"
        :key="idx"
        v-model="digits[idx]"
        @input="onDigitInput(idx)"
        @keypress="onKeypress($event)"
        @keydown.enter.prevent="emitEnter"
        @keydown="onKeydown(idx, $event)"
        @paste.prevent="onPaste($event)"
        :disabled="disabled"
        type="text"
        maxlength="1"
        autocomplete="one-time-code"
        inputmode="numeric"
        ref="cells"
        class="otp-cell"
      )
    div(
      v-if="errorMessage"
      class="otp-content__error"
    ) {{ errorMessage }}
</template>

<script>
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'MOtpInput',
  mixins: [responsive],
  model: { prop: 'value', event: 'input' },
  props: {
    value: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 6
    },
    errorMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      digits: Array.from({ length: this.length }, () => '')
    }
  },
  watch: {
    value(v) {
      this.sync(v)
    }
  },
  mounted() {
    this.sync(this.value)
    this.$refs.cells[0]?.focus()
  },
  methods: {
    sync(v = '') {
      const s = (v || '').padEnd(this.length, '').slice(0, this.length)
      this.digits = s.split('')
    },
    emitValue() {
      this.$emit('input', this.digits.join(''))
    },
    onDigitInput(idx) {
      this.digits[idx] = this.digits[idx].slice(-1)
      this.emitValue()
      const filledCount = this.digits.filter(ch => !!ch).length
      if (filledCount === this.length && this.xsDevice) {
        this.$emit('enter')
        return
      }
      if (this.digits[idx] && idx < this.length - 1) {
        this.$refs.cells[idx + 1]?.focus()
      }
    },
    onKeypress(e) {
      if (!/^\d$/.test(e.key) && e.key !== 'Enter') {
        e.preventDefault()
      }
    },
    emitEnter() {
      this.$emit('enter')
    },
    onKeydown(idx, e) {
      if (e.key !== 'Backspace' && e.key !== 'Delete') return

      e.preventDefault()
      if (this.digits[idx]) {
        this.digits[idx] = ''
        this.emitValue()
        return
      }
      if (e.key === 'Backspace' && idx > 0) {
        this.$refs.cells[idx - 1]?.focus()
        if (this.digits[idx - 1]) {
          this.digits[idx - 1] = ''
          this.emitValue()
        }
      }
    },
    onPaste(e) {
      e.preventDefault()
      const raw = (e.clipboardData || window.clipboardData).getData('text') || ''
      const digits = raw.replace(/\D/g, '').slice(0, this.length).split('')

      for (let i = 0; i < this.length; i++) {
        this.digits[i] = digits[i] || ''
      }

      this.emitValue()

      const next = digits.length >= this.length ? this.length - 1 : digits.length
      this.$refs.cells[next]?.focus()
    }
  }
}
</script>

<style scoped lang="scss">
.otp-input-container {
  margin-bottom: 24px;
}
.otp-input-fields {
  display: flex;
  margin-bottom: 12px;
  justify-content: space-between;
}
.otp-cell {
  width: 48px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 12px;
  outline: none;
}
.otp-cell:focus {
  border-color: #8f257d;
}

.otp-content__error {
  color: $danger;
  font-size: 14px;
  margin-top: 8px;
}

.otp-input-fields.otp-error {
  .otp-cell {
    border: 1px solid $danger;
  }
}
</style>
